;(function() {
  'use strict'

  Controller.$inject = ["surveyDOCXExporter"];
  angular.module('app.core').component('exportDocxDialog', {
    controller: Controller,
    templateUrl: 'export-docx-dialog.html',
    bindings: {
      survey: '<',
      onDone: '&',
      onCancel: '&',
    },
  })

  /* @ngInject */
  function Controller(surveyDOCXExporter) {
    var ctrl = this

    ctrl.$onInit = onInit
    ctrl.download = download

    function onInit() {
      ctrl.options = surveyDOCXExporter.getDefaultOptions()
    }

    function download() {
      surveyDOCXExporter.export(ctrl.survey, ctrl.options)
      ctrl.onDone()
    }
  }
})()
